import { Header } from '@lightspeed/design-system-react'
import { VendImage } from '@vend/react-utilities'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { LSPAYModalContent } from './LSPAYModalContent'

interface Props {
  headingType?: 'sub-heading' | 'heading'
  integrationType?: 'client-driven' | 'server-driven'
}

export const ConnectingToTerminal: FC<Props> = ({
  headingType = 'heading',
  integrationType = 'client-driven',
}) => {
  const t = useT()
  return (
    <LSPAYModalContent>
      <VendImage
        relativeImagePath="payments/terminal-connecting-v2.svg"
        relativeDarkImagePath="payments/terminal-connecting-darkmode-v1.svg"
        className="vd-mb2"
      />
      <Header type={headingType} level="2">
        {t('Connecting to terminal...', {
          _context: 'Payment connecting step header',
        })}
      </Header>
      <p data-testid={integrationType}>
        {t('This might take a while', {
          _context: 'Payment connecting step description',
        })}
      </p>
    </LSPAYModalContent>
  )
}
